// Global Components
import * as React from 'react';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Components
import InputText from '../InputText';

// Types
type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  onChange?: (value: null | string) => unknown;
  placeholder?: string;
  required?: boolean;
  unique?: (value: string) => Promise<boolean>;
  value?: null | string;
};

type $Props = $OptionalProps & {
  highlight: boolean;
  name: string;
};

type $State = {
  isUnique: boolean;
  value: null | string;
};

class InputUniqueTextView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    unique: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      isUnique: false,
      value: props.value || null,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      value,
    } = this.props;

    if (isDiff(
      value,
      prevProps.value,
    )) {
      const params = {
        value: value || null,
      };

      this.setValue(params);
    }
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async setValue({
    value,
  }: {
    value: null | string;
  }): Promise<void> {
    const {
      onChange,
      unique,
    } = this.props;

    let isUnique = true;

    if (unique && value !== null) {
      isUnique = await unique(value);
    }

    await this.setStateAsync({
      isUnique,
      value,
    });

    if (onChange) {
      onChange(value);
    }
  }

  render() {
    const {
      className,
      disabled,
      highlight,
      label,
      labelClassName,
      name,
      placeholder,
      required,
      unique,
    } = this.props;
    const {
      value,
    } = this.state;

    const validations = unique ? {
      unique: () => {
        const {
          isUnique,
        } = this.state;

        return isUnique || 'Not unique';
      },
    } : undefined;

    return (
      <InputText
        className={className}
        disabled={disabled}
        highlight={highlight}
        label={label}
        labelClassName={labelClassName}
        name={name}
        onChange={(newValue) => this.setValue({
          value: newValue,
        })}
        placeholder={placeholder}
        required={required}
        validations={validations}
        value={value}
      />
    );
  }
}

export default InputUniqueTextView;
